// extracted by mini-css-extract-plugin
export default {"app":"Setting_app__1+Ppu","headerBar":"Setting_headerBar__RtCx+","view":"Setting_view__Zp+xm"};